"use strict";
/**
 * Created by Ning Jiang on 4/1/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundEvent = void 0;
class SoundEvent {
}
SoundEvent.LOOPS_SETTING = "soundEvent_loopsSetting";
SoundEvent.EFFECTS_SETTING = "soundEvent_effectsSetting";
exports.SoundEvent = SoundEvent;
//# sourceMappingURL=SoundEvent.js.map